import { Card } from '@bancobarigui/barihaus';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { MonthlyEvolution } from '../types';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface MonthlyEvolutionChartProps {
  data: MonthlyEvolution[];
  loading?: boolean;
  onPointClick?: (month: string, year: number) => void;
}

export function MonthlyEvolutionChart({ data, loading = false, onPointClick }: MonthlyEvolutionChartProps) {
  const chartData = {
    labels: data.map(item => item.month),
    datasets: [
      {
        label: 'Total de Vistorias',
        data: data.map(item => item.total),
        borderColor: '#52c41a',
        backgroundColor: 'rgba(82, 196, 26, 0.2)',
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    onClick: (_event: any, elements: any[]) => {
      if (elements.length > 0 && onPointClick) {
        const index = elements[0].index;
        const item = data[index];
        onPointClick(item.month, item.year);
      }
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title="Evolução mensal de vistorias (últimos 12 meses)" bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '300px' }}>
          <Line data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
